import { apiClient } from '@/shared/api';
import type { KnowledgeSourceListItem, KnowledgeSourceListParams, KnowledgeSourceListResponse } from './types';

/**
 * Fetch a list of knowledge sources per GET /knowledge-source
 */
export const fetchKnowledgeSources = async (
  params?: KnowledgeSourceListParams,
): Promise<KnowledgeSourceListResponse> => {
  const { data } = await apiClient.get<KnowledgeSourceListResponse>('/knowledge-source', { params });
  return data;
};

/**
 * Получение источника знаний по идентификатору (GET /knowledge-source/{id}).
 * `silentError` подавляет toast: отсутствие источника — штатный случай, о нём сообщает сам UI
 */
export const fetchKnowledgeSource = async (id: number | string): Promise<KnowledgeSourceListItem> => {
  const { data } = await apiClient.get<KnowledgeSourceListItem>(`/knowledge-source/${id}`, { silentError: true });
  return data;
};
